var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bindEmail"},[(_vm.show)?_c('noBindEmail',{on:{"showLast":_vm.parentShow}}):_c('onBindEmail')],1)}
var staticRenderFns = []

export { render, staticRenderFns }